import { IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React from "react";

export const AddBoxButton = ({ record, isBoxMovementMode, onOpenMovementModal }) => {
	const isPalletMix = record.box_movements && record.box_movements.length > 0;
	const isPalletReserved = record.reserved_order_id != undefined;
	const hasBoxRecords = record.boxes?.length > 0;

	const totalBoxes =
		record.available_quantity != null ? record.available_quantity : record.quantity || 0;

	if (
		!isBoxMovementMode ||
		isPalletMix ||
		hasBoxRecords ||
		record.is_target ||
		isPalletReserved ||
		totalBoxes <= 0
	) {
		return null;
	}

	return (
		<IconButton size="small" color="primary" onClick={() => onOpenMovementModal(record)}>
			<AddIcon />
		</IconButton>
	);
};
